<template>
  <div id="invoices-page">

    <div class="first-row">
      <div class="heading-large">Invoices</div>
      <div class="date-picker">
        <div class="arrow arrow-left" @click="shiftByMonth(-1)">
          <i class="fas fa-chevron-left"></i>
        </div>
        <div class="arrow arrow-right" @click="shiftByMonth(1)">
          <i class="fas fa-chevron-right"></i>
        </div>
      </div>
      <div class="heading-medium">{{ _currentMonth }}</div>
    </div>

    <div class="second-row row">
      <div class="col">
        <pending-clients :startDate="startDate" :endDate="endDate"></pending-clients>
      </div>
      <div class="col">
        <invoiced-clients :startDate="startDate" :endDate="endDate"></invoiced-clients>
      </div>
    </div>
  </div>
</template>
<script>
import DateRangePicker from 'vue2-daterange-picker/src/components/DateRangePicker'
import PendingClients from './PendingClients.vue'
import InvoicedClients from './InvoicedClients.vue'

export default {
  components: {
    DateRangePicker,
    InvoicedClients,
    PendingClients
  },
  data() {
    return {
      startDate: moment().startOf('month').format('YYYY-MM-DD'),
      endDate: moment().endOf('month').format('YYYY-MM-DD'),
      monthCounter: 0,
    }
  },
  computed: {
    _currentMonth() {
      return moment().add(this.monthCounter, 'month').format('YYYY MMMM')
    }
  },
  methods: {
    onDateRangeSelected(event) {
      this.startDate = moment(event.startDate).format('YYYY/-MM-DD')
      this.endDate = moment(event.endDate).format('YYYY-MM-DD')
    },
    shiftByMonth(n) {
      this.monthCounter += n
      this.startDate = moment().add(this.monthCounter, 'month').startOf('month').format('YYYY-MM-DD')
      this.endDate = moment().add(this.monthCounter, 'month').endOf('month').format('YYYY-MM-DD')
      this.$nextTick(() => {
        this.$root.$emit('Invoices::changeDate')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/invoices2/Index.vue